import { FooterSectionText } from '../helpers/types/footer'

import Section from '@/components/atomic/molecules/Section'
import Text from '@/components/atomic/atoms/Text'
import COLOR from '@/components/cell/designTokens/color'
import { cn } from '@/shared/utils/class-name-utils'

interface Props {
  title: string
  textsList: FooterSectionText[][]
  onClick?: (item: FooterSectionText) => void
}

const FooterSection = ({ title, textsList, onClick }: Props) => {
  return (
    <Section padding={0} hasDivider={false} className="mb-[21px] [&_h3]:mb-[9px] [&_a]:no-underline">
      <Text element="h3" color={COLOR.gray800} type="title4">
        {title}
      </Text>
      <ul className="grid grid-cols-2 gap-x-4 gap-y-[2px] p-0 m-0 list-none">
        {textsList.map((texts, textsIndex) => (
          <li key={`section_${textsIndex}`} className="whitespace-pre mb-2 last:mb-0">
            {texts.map((text, textIndex) =>
              text.url === undefined ? (
                <Text
                  className={text.onClick ? 'cursor-pointer' : ''}
                  key={`section_${textsIndex}_${textIndex}`}
                  element="span"
                  color={COLOR.gray800}
                  type="caption2"
                  onClick={() => text.onClick?.()}
                >
                  {text.value}
                </Text>
              ) : (
                <a
                  key={`section_${textsIndex}_${textIndex}`}
                  href={text.url}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => onClick?.(text)}
                >
                  <p
                    className={cn(
                      'm-0 whitespace-normal text-[12px] leading-[16px]',
                      text.key?.includes('privacy') ? 'font-bold underline' : '',
                    )}
                    style={{ color: COLOR.gray800 }}
                  >
                    {text.value}
                  </p>
                </a>
              ),
            )}
          </li>
        ))}
      </ul>
    </Section>
  )
}

export default FooterSection
